@import 'styles/mixins';
@import 'styles/variables';

.dropdown {
  box-shadow: $shadow-s3;
  background: $white;
  border-radius: 8px;
  padding: 4px;
  max-height: 300px;
  width: 285px;
  overflow-y: scroll;
  @include hide-scrollbar;
}

.avatar {
  width: 20px;
  align-items: center;
  flex-shrink: 0;
}

.title {
  @include line-clamp;
}
